import React from "react"

import { DeleteFavoritesOverlay } from "./DeleteFavoritesOverlay"
import { useDeleteFavoritesOverlayModel } from "./hooks/useDeleteFavoritesOverlayModel"

export interface DeleteFavoritesOverlayPayload {
  itemIDsToDelete: string[]
}

export interface DeleteFavoritesOverlayConnectorProps {
  payload: DeleteFavoritesOverlayPayload
}

export const DeleteFavoritesOverlayConnector = React.memo(
  (props: DeleteFavoritesOverlayConnectorProps) => (
    <DeleteFavoritesOverlay
      autoFocus
      {...useDeleteFavoritesOverlayModel(props)}
    />
  )
)

declare module "shared/context/overlay/registry" {
  interface OverlayPayloadRegistry {
    DELETE_FAVORITES_OVERLAY: DeleteFavoritesOverlayPayload
  }
}
